import {
  CTextAlign,
  type ActionGroupFragment,
  type BoxFragment,
  type ImageBlockFragment,
  type ImageBlockGroupFragment,
} from '@seek/cmsu-cms-connect';
import { Box } from 'braid-design-system';
import React from 'react';

import { InlineImageBlock } from './InlineImageBlock';
import { RegularImageBlock } from './RegularImageBlock';

type Props = Pick<
  ImageBlockFragment,
  | 'heading'
  | 'image'
  | 'paragraph'
  | 'cButtonLink'
  | 'cTextLink'
  | 'dialogButton'
  | 'reverseContent'
  | 'accentBar'
  | 'actionGroup'
> &
  Pick<
    ImageBlockGroupFragment,
    | 'inlineBlockItem'
    | 'blockBackground'
    | 'blockBorder'
    | 'imageAlignment'
    | 'stackBelow'
    | 'inlineBlockContentLayout'
  > & {
    inlineTextJustify?: BoxFragment['justifyContent'];
    textAlign?: BoxFragment['textAlign'];
  };

const ImageBlock = ({
  image,
  heading,
  paragraph,
  inlineBlockItem,
  blockBackground,
  blockBorder,
  imageAlignment,
  actionGroup,
  cButtonLink,
  cTextLink,
  dialogButton,
  stackBelow,
  inlineTextJustify,
  textAlign = CTextAlign.Center,
  reverseContent,
  accentBar,
  inlineBlockContentLayout,
}: Props) => {

  // If actionGroup is provided, use it. Otherwise, if cButtonLink, cTextLink,
  // or dialogButton is provided, create an action group from those.
  const actions: Omit<ActionGroupFragment, 'locale'> | undefined = actionGroup ||
    (cButtonLink || cTextLink || dialogButton ? {
      actions: [cButtonLink, cTextLink, dialogButton].filter(Boolean) as ActionGroupFragment['actions'],
      alignment: textAlign,
    } : undefined);

  return (
    <Box data={{ testid: 'ImageBlockTestId' }} height="full">
      {inlineBlockItem ? (
        <InlineImageBlock
          imageAlignment={imageAlignment}
          heading={heading}
          image={image}
          paragraph={paragraph}
          blockBackground={blockBackground}
          blockBorder={blockBorder}
          actions={actions}
          inlineTextJustify={inlineTextJustify}
          stackBelow={stackBelow}
          reverseContent={reverseContent}
          accentBar={accentBar}
          inlineBlockContentLayout={inlineBlockContentLayout}
        />
      ) : (
        <RegularImageBlock
          heading={heading}
          image={image}
          imageAlignment={imageAlignment}
          textAlign={textAlign}
          paragraph={paragraph}
          blockBackground={blockBackground}
          blockBorder={blockBorder}
          actions={actions}
          reverseContent={reverseContent}
        />
      )}
    </Box>
  )
};
export { ImageBlock };
